
import {
  defineComponent, ref, toRefs, watch,
} from 'vue';
import { rpcClient } from '@/apis';
import { CardLectureItem, CardLecture } from '@/components/listCard';
import { useScrollToBottom, useRouterBack } from '@/composables';
import { RatingHeadBar } from './components';

export default defineComponent({
  components: {
    RatingHeadBar,
    CardLecture,
  },
  props: {
    /** 传入的搜索字串 */
    q: { type: String, required: true },
  },
  setup(props) {
    const { q } = toRefs(props);

    /** 搜索结果列表 */
    const searchResults = ref<CardLectureItem[]>([]);

    /** 搜索并覆盖当前列表 */
    const search = () => {
      if (q.value) {
        rpcClient.search({ q: q.value, limit: 20 }).then((resp) => {
          searchResults.value = resp.data;
        });
      }
    };
    /** 搜索并将结果附加在当前列表后 */
    const searchMore = () => {
      // TODO: 传入 lastId
      if (q.value) {
        rpcClient
          .search({
            q: q.value,
            lastId: searchResults.value[searchResults.value.length - 1].id,
            limit: 20,
          })
          .then((resp) => {
            searchResults.value = [...searchResults.value, ...resp.data];
          });
      }
    };

    watch(q, () => {
      // q 改变时重新拉数据
      search();
    });

    // 滚动到底部时拉新数据
    const { scrollRef: scroll } = useScrollToBottom(searchMore);

    // 首次进入该页面拉数据
    search();

    return {
      /** 列表元素 ref */
      scroll,

      /** 搜索结果列表 */
      searchResults,

      /** 路由回退 */
      routerBack: useRouterBack(),
    };
  },
  computed: {
    parsedQ(): string {
      if (this.q.length < 12) {
        return this.q;
      }
      return `${this.q.slice(0, 12)}...`;
    },
  },
});
